export const IntegrationProviders = {
    KLAVIYO: 'Klaviyo',
    META: 'Meta',
    GOOGLE_ADS: 'GOOGLE_ADS',
    SHOPIFY: 'shopify',
    TIKTOK_ADS: 'TIKTOK_ADS',
    AXON: 'AXON',
    LINKEDIN_ADS: 'LINKEDIN_ADS',
    TRIPLEWHALE: 'TRIPLEWHALE',
    NORTHBEAM: 'NORTHBEAM',
}

export const BASE_PATH_AFTER_SUCCESSFUL_AUTH = '/account'
export const AUTH_BASE_PATH = '/auth/login'

// sessionStorage key used to round-trip a user through the existing login/register
// flow and land them back on the MCP OAuth consent page (see McpConnectPage +
// AuthContext.getAuthEntitiesAndSetSession). There's no generic `redirect`/`returnTo`
// query param in this app — every login/register path hardcodes its own post-auth
// destination — so this is the deliberate fallback for that one deep link.
export const MCP_CONNECT_RETURN_URL_KEY = 'mcpConnectReturnUrl'
// Deep link (e.g. a shared creative) a signed-out user opened; restored after sign-in.
export const AUTH_RETURN_URL_KEY = 'authReturnUrl'

// u_source value stamped on a signup that arrived through the MCP connector
// consent flow (see useRegister + McpConnectPage). Generic on purpose — we do
// not distinguish which MCP client (Claude / Cursor / …) drove the signup.
export const MCP_CONNECTOR_SOURCE = 'mcp_connector'

// let basePath = 'creative'
// try {
//     const basePathFromLocalStorage = localStorage.getItem('basePath')
//     if (basePathFromLocalStorage) {
//         basePath = basePathFromLocalStorage
//     }
// } catch (e) {
//     console.error(e)
// }

export const DASHBOARD_ROOT = 'creative/home'

export const UserRoles = {
    OWNER: 'owner',
    ADMIN: 'admin',
    EDITOR: 'editor',
    VIEWER: 'viewer',
    GUEST: 'guest',
}

export const RoleToWeight = {
    [UserRoles.OWNER]: 100,
    [UserRoles.ADMIN]: 90,
    [UserRoles.EDITOR]: 30,
    [UserRoles.VIEWER]: 20,
    [UserRoles.GUEST]: 10,
}
